// removed by extract-text-webpack-plugin
module.exports = {"anchorText":"anchorText--2QcuO"};